import * as Types from '../../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAppConfigVariables = Types.Exact<{ [key: string]: never }>;

export type GetAppConfig = {
  appConfig: Pick<
    Types.AppConfig,
    | 'accountId'
    | 'alertSummariesEnabled'
    | 'awsPartition'
    | 'datadogRumEnabled'
    | 'pantherCommit'
    | 'pantherDataLakeType'
    | 'databaseApi'
    | 'salesPhase'
    | 'awsAccountAlias'
    | 'awsOrgId'
    | 'customerName'
    | 'contractStartDate'
    | 'contractEndDate'
    | 'created'
    | 'datadogWebServiceName'
    | 'datadogWebApplicationId'
    | 'datadogWebClientToken'
    | 'enableDatalakeRbac'
    | 'maxLookupTableCompressedSizeInMb'
    | 'snowflakeAdminSecretArn'
    | 'snowflakeClusterArns'
    | 'snowflakeReadonlySecretArn'
    | 'splitClientToken'
    | 'enableClassyDetections'
    | 'enableDataExplorerTruncation'
    | 'enablePantherGitConfiguration'
    | 'enableReplays'
    | 'enableReports'
    | 'enableDetectionFilters'
    | 'enableExperimentalCrowdstrikeParsing'
    | 'pylonAppId'
    | 'processedDataBucketRetentionDays'
    | 'publicHTTPIngestDomain'
    | 'aiEnableScheduledPrompts'
    | 'remoteMcpEnabled'
    | 'awsMcpEnabled'
    | 'aiEnableRunbooks'
  >;
};

export const GetAppConfigDocument = gql`
  query GetAppConfig {
    appConfig {
      accountId
      alertSummariesEnabled
      awsPartition
      datadogRumEnabled
      pantherCommit
      pantherDataLakeType
      databaseApi
      salesPhase
      awsAccountAlias
      awsOrgId
      customerName
      contractStartDate
      contractEndDate
      created
      datadogWebServiceName
      datadogWebApplicationId
      datadogWebClientToken
      enableDatalakeRbac
      maxLookupTableCompressedSizeInMb
      snowflakeAdminSecretArn
      snowflakeClusterArns
      snowflakeReadonlySecretArn
      splitClientToken
      enableClassyDetections
      enableDataExplorerTruncation
      enablePantherGitConfiguration
      enableReplays
      enableReports
      enableDetectionFilters
      enableExperimentalCrowdstrikeParsing
      pylonAppId
      processedDataBucketRetentionDays
      publicHTTPIngestDomain
      aiEnableScheduledPrompts
      remoteMcpEnabled
      awsMcpEnabled
      aiEnableRunbooks
    }
  }
`;

/**
 * __useGetAppConfig__
 *
 * To run a query within a React component, call `useGetAppConfig` and pass it any options that fit your needs.
 * When your component renders, `useGetAppConfig` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppConfig({
 *   variables: {
 *   },
 * });
 */
export function useGetAppConfig(
  baseOptions?: Apollo.QueryHookOptions<GetAppConfig, GetAppConfigVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAppConfig, GetAppConfigVariables>(GetAppConfigDocument, options);
}
export function useGetAppConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAppConfig, GetAppConfigVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAppConfig, GetAppConfigVariables>(GetAppConfigDocument, options);
}
export function useGetAppConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppConfig, GetAppConfigVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAppConfig, GetAppConfigVariables>(
    GetAppConfigDocument,
    options,
  );
}
export type GetAppConfigHookResult = ReturnType<typeof useGetAppConfig>;
export type GetAppConfigLazyQueryHookResult = ReturnType<typeof useGetAppConfigLazyQuery>;
export type GetAppConfigSuspenseQueryHookResult = ReturnType<typeof useGetAppConfigSuspenseQuery>;
export type GetAppConfigQueryResult = Apollo.QueryResult<GetAppConfig, GetAppConfigVariables>;
export function mockGetAppConfig({
  data,
  variables,
  errors,
}: {
  data: GetAppConfig;
  variables?: GetAppConfigVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetAppConfigDocument, variables },
    result: { data, errors },
  };
}
